export default {"src":"/_next/static/media/account_settings_selected.05a533c5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};